export type CardTypeCategory =
  | "mostly_personal"
  | "some_commercial"
  | "mostly_commercial";

export const CATEGORY_TO_PERCENTAGE_MAP: Record<CardTypeCategory, number> = {
  mostly_personal: 95,
  some_commercial: 70,
  mostly_commercial: 30,
};

export type CardFee = {
  cardType: string;
  category: "Personal" | "Commercial";
  interchange: number;
  schemeFee: number;
};

export const CARD_FEES: Array<CardFee> = [
  {
    cardType: "VISA Personal Debit",
    category: "Personal",
    interchange: 0.2,
    schemeFee: 0.207,
  },
  {
    cardType: "VISA Personal Credit",
    category: "Personal",
    interchange: 0.3,
    schemeFee: 0.207,
  },
  {
    cardType: "VISA Commercial",
    category: "Commercial",
    interchange: 1.6,
    schemeFee: 0.207,
  },
  {
    cardType: "Mastercard Personal Debit",
    category: "Personal",
    interchange: 0.2,
    schemeFee: 0.31,
  },
  {
    cardType: "Mastercard Personal Credit",
    category: "Personal",
    interchange: 0.3,
    schemeFee: 0.31,
  },
  {
    cardType: "Mastercard Commercial",
    category: "Commercial",
    interchange: 1.5,
    schemeFee: 0.31,
  },
  {
    cardType: "Maestro Commercial",
    category: "Commercial",
    interchange: 1.5,
    schemeFee: 0.31,
  },
];
